import { ReactComponent as LaurelLeft } from "./laurelLeft.svg"
import { ReactComponent as LaurelRight } from "./laurelRight.svg"
import styles from "./SocialProofBanner.module.scss"

const StarIcon = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none">
    <rect className={styles.starBg} width="16" height="15" rx="2" />
    <path
      d="M8 3L9.2 6.8H13.2L10 9.1L11.2 12.9L8 10.6L4.8 12.9L6 9.1L2.8 6.8H6.8L8 3Z"
      fill="white"
    />
  </svg>
)

const AlmostFullStarIcon = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none">
    <rect className={styles.starBgEmpty} width="16" height="15" rx="2" />
    <rect className={styles.starBg} width="14" height="15" rx="2" />
    <path
      d="M8 3L9.2 6.8H13.2L10 9.1L11.2 12.9L8 10.6L4.8 12.9L6 9.1L2.8 6.8H6.8L8 3Z"
      fill="white"
    />
  </svg>
)

const SocialProofBanner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.statGroup}>
        <LaurelLeft className={styles.laurel} />
        <div className={styles.stat}>
          <span className={styles.statValue}>10M+</span>
          <span className={styles.statLabel}>Users</span>
        </div>
        <LaurelRight className={styles.laurel} />
      </div>
      <div className={styles.statGroup}>
        <LaurelLeft className={styles.laurel} />
        <div className={styles.stat}>
          <div className={styles.stars}>
            <StarIcon />
            <StarIcon />
            <StarIcon />
            <StarIcon />
            <AlmostFullStarIcon />
          </div>
          <span className={styles.statLabel}>4.9 star rating</span>
        </div>
        <LaurelRight className={styles.laurel} />
      </div>
    </div>
  )
}

export default SocialProofBanner
